import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const GlobalStyle = createGlobalStyle`
    ${reset}

    *{
        box-sizing: border-box;
        font-family: -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif;
    }

    body {
        font-family: -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif;
        color: #2f2f38;
    }

    button {
        cursor: pointer;
        outline: none;
        border: none;
        background-color: inherit;

        &:disabled {
            cursor: not-allowed;
        }
    }

    input {
        outline: none;
        border: none;

        &::placeholder {
            font-family: -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif;
        }
    }

    input[type=button] {
      -webkit-appearance: none;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;             
        margin: 0;         
    }

    input[type=checkbox] {
        margin: 0;
    }

    a {
       text-decoration: none
    }

    textarea {
        border: none;
        outline: none;
    }

    text {
        font-family: -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif !important;
    }
`;
